module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-06.a9b9a924.png";